var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteKcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 109,
    viewBox: "0 0 129 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5 0C99.8474 0 128.5 24.2896 128.5 54.2459C128.5 84.2017 99.8474 108.475 64.5 108.475C29.1695 108.475 0.5 84.1849 0.5 54.2287C0.5 24.2727 29.1523 0 64.5 0ZM76.7827 12.1883H52.868V46.688C50.1418 40.4044 44.0853 34.8611 37.9253 31.1082H11.9571C20.3774 37.3746 33.6634 47.1874 33.6634 55.0205C33.6634 58.9112 28.9184 59.7027 26.2267 59.7027H9.85203V78.4675H35.5097C41.2554 78.4675 49.5203 76.3846 52.868 67.5357V92.6873H76.7827V67.5357C80.13 76.3846 88.3951 78.4675 94.1408 78.4675H119.799V59.7027H103.424C100.715 59.7027 95.987 58.9282 95.987 55.0205C95.987 47.1874 109.29 37.3746 117.693 31.1082H91.7253C85.5654 34.8611 79.509 40.3873 76.7827 46.688V12.1883Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteKcLogo);
export default __webpack_public_path__ + "static/media/whiteKCLogo.76079fd2f7e31272ca1b129666e3fec2.svg";
export { ForwardRef as ReactComponent };